const SpecialistOne = () => {
  return (
    <section className='specialist py-120'>
      <div className='container'>
        <div className='section-heading text-center'>
          <div className='flex-align d-inline-flex gap-8 mb-16 wow bounceInDown'>
            <span className='text-main-600 text-2xl d-flex'>
              <i className='ph-bold ph-book-open' />
            </span>
            <h5 className='text-main-600 mb-0'>Find Our Specialist</h5>
          </div>
          <h2 className='mb-24 wow bounceIn'>Find Your Subject Specialist</h2>
        </div>
        <div className='row gy-4'>
          <div className='col-xxl-3 col-lg-4 col-sm-6 wow bounceIn'>
            <div className='ps-40 pe-8 rounded-12 animation-item bg-main-25 py-24 flex-align gap-24'>
              <span className='text-main-600'>
                <img
                  src='assets/images/icons/specialist-icon1.png'
                  alt=''
                  className='animate__heartBeat'
                />
              </span>
              <h4 className='mb-0'>Bangla</h4>
            </div>
          </div>
          <div className='col-xxl-3 col-lg-4 col-sm-6 wow bounceIn'>
            <div className='ps-40 pe-8 rounded-12 animation-item bg-main-two-25 py-24 flex-align gap-24'>
              <span className='text-main-two-600'>
                <img
                  src='assets/images/icons/specialist-icon2.png'
                  alt=''
                  className='animate__heartBeat'
                />
              </span>
              <h4 className='mb-0'>English</h4>
            </div>
          </div>
          <div className='col-xxl-3 col-lg-4 col-sm-6 wow bounceIn'>
            <div className='ps-40 pe-8 rounded-12 animation-item bg-main-three-25 py-24 flex-align gap-24'>
              <span className='text-main-three-600'>
                <img
                  src='assets/images/icons/specialist-icon3.png'
                  alt=''
                  className='animate__heartBeat'
                />
              </span>
              <h4 className='mb-0'>Mathematics</h4>
            </div>
          </div>
          <div className='col-xxl-3 col-lg-4 col-sm-6 wow bounceIn'>
            <div className='ps-40 pe-8 rounded-12 animation-item bg-main-two-25 py-24 flex-align gap-24'>
              <span className='text-main-two-600'>
                <img
                  src='assets/images/icons/specialist-icon4.png'
                  alt=''
                  className='animate__heartBeat'
                />
              </span>
              <h4 className='mb-0'>Biology</h4>
            </div>
          </div>
          <div className='col-xxl-3 col-lg-4 col-sm-6 wow bounceIn'>
            <div className='ps-40 pe-8 rounded-12 animation-item bg-main-two-25 py-24 flex-align gap-24'>
              <span className='text-main-two-600'>
                <img
                  src='assets/images/icons/specialist-icon5.png'
                  alt=''
                  className='animate__heartBeat'
                />
              </span>
              <h4 className='mb-0'>Physics</h4>
            </div>
          </div>
          <div className='col-xxl-3 col-lg-4 col-sm-6 wow bounceIn'>
            <div className='ps-40 pe-8 rounded-12 animation-item bg-main-three-25 py-24 flex-align gap-24'>
              <span className='text-main-three-600'>
                <img
                  src='assets/images/icons/specialist-icon6.png'
                  alt=''
                  className='animate__heartBeat'
                />
              </span>
              <h4 className='mb-0'>Chemistry</h4>
            </div>
          </div>
          <div className='col-xxl-3 col-lg-4 col-sm-6 wow bounceIn'>
            <div className='ps-40 pe-8 rounded-12 animation-item bg-main-two-25 py-24 flex-align gap-24'>
              <span className='text-main-two-600'>
                <img
                  src='assets/images/icons/specialist-icon7.png'
                  alt=''
                  className='animate__heartBeat'
                />
              </span>
              <h4 className='mb-0'>ICT &amp; IT</h4>
            </div>
          </div>
          <div className='col-xxl-3 col-lg-4 col-sm-6 wow bounceIn'>
            <div className='ps-40 pe-8 rounded-12 animation-item bg-main-25 py-24 flex-align gap-24'>
              <span className='text-main-600'>
                <img
                  src='assets/images/icons/specialist-icon8.png'
                  alt=''
                  className='animate__heartBeat'
                />
              </span>
              <h4 className='mb-0'>Geography</h4>
            </div>
          </div>
          <div className='col-xxl-3 col-lg-4 col-sm-6 wow bounceIn'>
            <div className='ps-40 pe-8 rounded-12 animation-item bg-main-three-25 py-24 flex-align gap-24'>
              <span className='text-main-three-600'>
                <img
                  src='assets/images/icons/specialist-icon9.png'
                  alt=''
                  className='animate__heartBeat'
                />
              </span>
              <h4 className='mb-0'>Architecture</h4>
            </div>
          </div>
          <div className='col-xxl-3 col-lg-4 col-sm-6 wow bounceIn'>
            <div className='ps-40 pe-8 rounded-12 animation-item bg-main-two-25 py-24 flex-align gap-24'>
              <span className='text-main-two-600'>
                <img
                  src='assets/images/icons/specialist-icon10.png'
                  alt=''
                  className='animate__heartBeat'
                />
              </span>
              <h4 className='mb-0'>Business</h4>
            </div>
          </div>
          <div className='col-xxl-3 col-lg-4 col-sm-6 wow bounceIn'>
            <div className='ps-40 pe-8 rounded-12 animation-item bg-main-25 py-24 flex-align gap-24'>
              <span className='text-main-600'>
                <img
                  src='assets/images/icons/specialist-icon11.png'
                  alt=''
                  className='animate__heartBeat'
                />
              </span>
              <h4 className='mb-0'>History</h4>
            </div>
          </div>
          <div className='col-xxl-3 col-lg-4 col-sm-6 wow bounceIn'>
            <div className='ps-40 pe-8 rounded-12 animation-item bg-main-two-25 py-24 flex-align gap-24'>
              <span className='text-main-two-600'>
                <img
                  src='assets/images/icons/specialist-icon12.png'
                  alt=''
                  className='animate__heartBeat'
                />
              </span>
              <h4 className='mb-0'>Philosophy</h4>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecialistOne;
